import {Pipe, PipeTransform} from '@angular/core';
import {NotificationSubTypesEnums, NotificationTypesEnums} from '../../enums/notification-enums';

@Pipe({
  name: 'handleShowNotificationImg',
  standalone: true
})
export class HandleShowNotificationImagePipe implements PipeTransform {

  transform(notification: any): boolean {
    return (notification.type === NotificationTypesEnums.newLike && notification.data.like.likeable_type === NotificationSubTypesEnums.postSubType)
      || (notification.type === NotificationTypesEnums.newComment && notification.data.comment.commentable_type === NotificationSubTypesEnums.postSubType);
  }

}
